window.dataLayer = window.dataLayer || [];

import { parse } from 'postcode';
import { clickHandler } from '@/scripts/analytics/analytics.methods';

const eventName = 'distributorSearch_tracking';
const actionPropTitle = 'distributorSearch_action';
const labelPropTitle = 'distributorSearch_label';

const elements = [
  ...document.querySelectorAll(
    '.js-distributor-search-form-ga, .js-distributor-search-form-results-ga',
  ),
];

function bindEventListener(el) {
  el.addEventListener('submit', (e) => {
    clickHandler(
      {
        event: eventName,
        actionProp: actionPropTitle,
        labelProp: labelPropTitle,
        action: 'Click' + determineSearchResults(el),
        label: `${determineSubmitText(el)} - ${determineSelectValues(el).trim()}`,
      },
      e,
    );
  });
}

function determineSelectValues(el) {
  const fd = new FormData(el);
  const value = Array.from(fd.entries(), (field) => field[1])[0];
  const pc = parse(value);
  return pc.valid ? pc.outcode : value;
}

function determineSubmitText(el) {
  return el.querySelector('button').innerText;
}

function determineSearchResults(el) {
  if (!el.classList.contains('js-distributor-search-form-results-ga')) {
    return '';
  } else {
    return ' - Search again';
  }
}

function init() {
  if (!elements.length) {
    return;
  }
  elements.forEach(bindEventListener);
}

export default init;
